export default __webpack_public_path__ + "static/media/104t.972d2f32.jpg";